import script from "./ImageUploaderNeue.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageUploaderNeue.vue?vue&type=script&setup=true&lang=js"

import "./ImageUploaderNeue.vue?vue&type=style&index=0&id=2c5e8ef4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.38_vue@3.5.38_webpack@5.107.2_postcss@8.5.15_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c5e8ef4"]])

export default __exports__

/* vue-cli-plugin-import-components */

import BasicSpinner from "@/components/BasicSpinner.vue";
import NeueButton from "@/components/neue/NeueButton.vue";
script.components = Object.assign({}, { BasicSpinner, NeueButton }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { BasicSpinner, NeueButton }, script.__o.components);}